require('./contractEasyLoanWrapper.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require("react-router-dom");
const actionsAccount = require('actions/accounts');
const ContractEasyLoanView = require('../contractEasyLoanView/contractEasyLoanView');
const ContractEasyLoanTypeCView = require('../contractEasyLoanTypeCView/contractEasyLoanTypeCView');
const { LoadingSection } = require('commonsComponents/loadingSection');
const LoansError = require('components/loansAndMortgages/loans/loansError/loansError');

class ContractEasyLoanWrapper extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { validateBlockedAccount } = this.props;
        validateBlockedAccount();
    }

    render() {

        const { immContractEasyLoanTypeC, hiringProductBanners } = this.props
        const showTypeC = immContractEasyLoanTypeC.get('showTypeC');
        const isAccountBlockedValidationFetching = hiringProductBanners.get('isAccountBlockedValidationFetching');
        const isAccountBlockedValidationError = hiringProductBanners.get('isAccountBlockedValidationError');

        return (
            <>
                {
                    isAccountBlockedValidationFetching ?
                        <div className="contract-easy-loan-wrapper__loading"><LoadingSection /></div>
                        :
                        isAccountBlockedValidationError ?
                            <div className="container-fluid"><div className="contract-easy-loan-wrapper__error"><LoansError /></div></div>
                            :
                            showTypeC ? <ContractEasyLoanTypeCView /> : <ContractEasyLoanView />
                }
            </>

        )
    }
}

ContractEasyLoanWrapper.propTypes = {
    hiringProductBanners: PropTypes.object.isRequired,
    immContractEasyLoanTypeC: PropTypes.object.isRequired,
    validateBlockedAccount: PropTypes.func.isRequired,
};

module.exports.constructor = ContractEasyLoanWrapper;
module.exports = withRouter(connect(
    state => ({
        hiringProductBanners: state.hiringProductBanners,
        immContractEasyLoanTypeC: state.contractEasyLoanTypeC
    }),
    {
        validateBlockedAccount: actionsAccount.validateBlockedAccount,
    }
)(ContractEasyLoanWrapper));
